module.exports = __webpack_public_path__ + "static/media/darkgrey_grid.f638bd36.svg";